module.exports = __webpack_public_path__ + "static/media/sup_tropical_1920.2119ea77.webp";